<dx-popup
  [width]="400"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'ACTIVATE-USERS.OVERVIEW.TITLE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [(visible)]="showModal"
  class="modal"
  [classList]="'modal'"
>
  <div *dxTemplate="let data of 'content'">
    <p class="description">{{ 'ACTIVATE-USERS.OVERVIEW.TEXT' | translate }}</p>
    <p>{{ 'COMMON.FIELDS.USERS' | translate }}:</p>
    <dx-list 
      [dataSource]="persons"
      [height]="150"
    >
      <div *dxTemplate="let user of 'item'">
        <span>{{ user.lastName }} {{ user.firstName }}</span>
      </div>
    </dx-list>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="cancelButtonOptions"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="activateButtonOptions"
  ></dxi-popup-toolbar-item>
</dx-popup>